<template>
	<div class="List-home padding-t50">
    <div class="comTitle">
        <p>本院动态</p>
        <span>Dynamic of our COLLEGE</span>
        <em></em>
    </div>
  <ul>
			<li v-for="(item,index) in xxggList" :key='item.ID' @mouseenter="hoverRoll(item)" class="wow fadeInLeft" :data-wow-delay="index/5+'s'">
					<router-link  :to="item.Url" :href="item.Url"  @click.native="OpenLink(item.Url)"  >
							<!-- <div class="imgBox"> <img :src="item.Cover" /></div>-->
							<div class="time"><span>{{setTimeformat(item.ShowTime6,'mm-dd') }} </span> <em>{{setTimeformat(item.ShowTime6,'YYYY') }}</em></div>
							<div class="textBox">
								<p class="title txt-cut1" :title="item.Title">{{item.Title}}</p>
								<p class="text txt-cut2">{{item.Describe.substring(0,50)}}</p>
							</div>
					</router-link>
			</li>
		</ul>
    <a v-if="moreLink" class="moreBtn wow zoomIn" data-wow-delay="0.3s">
    	<router-link :to="moreLink"><i>查看更多+</i></router-link>
    </a>
	</div>
</template>

<script>
	export default{
		name:'xxgg',
		props:{
			xxggList:{
				type:Array,
				default:()=>[]
			},
			moreLink: {
			   type: String,
			   default: ''
			},
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				 return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			  this.item = _data
			}
		}
	}
</script>

<style lang='less' scoped>
  @li-width: 100%;
  @li-height: 0.95rem;
  @li-padding: 0.25rem;
 .List-home{width: 6.9rem;  margin: 0 auto;  padding-bottom: 0px; font-size: 0; }
 .List-home ul{  padding-top: 0px;width: @li-width; display: block; padding-bottom: 0;padding-top: 0.4rem;  }
 .List-home ul>li{ width: 6.9rem;   margin-bottom: 0.1rem; font-size: 0; }
 .List-home ul>li>a{ width: 6.4rem;padding:@li-padding; box-shadow: 0px 0px 0.06rem rgba(0, 0, 0, 0.16); background: #fff; margin-bottom: 0.3rem; font-size: 0;  display: block;}
 .List-home ul>li>a>.time{display: inline-block;vertical-align: top; width: 0.5rem;  font-size: 0.22rem; padding-top: 0.05rem ;  text-align: left; overflow: visible;  line-height: 1.5;  color: #999999; height: 0.95rem; border-bottom: 0.02rem solid #CBCBCB;   }
  .List-home ul>li:hover>a>.time>span{color: #0376be;}
 .List-home ul>li>a>.time>span{ display: inline-block; font-size: 0.32rem; width: 1.6rem; color: #000;letter-spacing: 0.01rem; }
//  .List-home ul>li:hover>a>.time{ color: #fff; border-right: 1px solid #fff;  }
//  .List-home ul>li:hover{background: $themeColor; }
 .List-home ul>li .textBox{ display: inline-block; width: 5.3rem; vertical-align: top;padding: 0;padding-left: 0.6rem; }
 .List-home ul>li .textBox .title{  font-size: 0.28rem; height: 0.28rem; color: #333; line-height: 1; padding-top: 0.15rem;  text-align: justify;}
 .List-home ul>li:hover .textBox .title{
   color:  #0376be;
 }
 .List-home ul>li .textBox .text{  font-size: 0.26rem; color: #666;line-height: 1.5; text-align: justify; padding-top:0.15rem;}

</style>



// WEBPACK FOOTER //
// src/components/xxgg.vue